module.exports = __webpack_public_path__ + "media/images/shark/SharkCafeMap-p-800-967368a9b4d65877cdc6b92bb6b4aaa8.jpg";